import PropTypes from 'prop-types'
import classNames from 'classnames'

const Glyph = ({ glyph, direction }) => {
  const classes = classNames({
    'align-middle': true,
    glyph: true,
    [`glyph-${glyph}`]: true,
    [`glyph-${glyph}-${direction}`]: direction
  })

  return <i className={classes} />
}

Glyph.prototype = {
  glyph: PropTypes.string,
  className: PropTypes.string,
  direction: PropTypes.string
}

export default Glyph
